import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "@/App";

import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/ErrorBoundary';
import { initGA, initGTM } from './utils/analytics';

// Initialize Google Analytics & Tag Manager
if (process.env.NODE_ENV === 'production') {
  initGA();
  initGTM();
}

// Register Service Worker for PWA and Push Notifications
// Her ortamda register et (production + vercel preview + localhost)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        setInterval(() => registration.update(), 60 * 60 * 1000);
      })
      .catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ErrorBoundary>
);
